document.addEventListener('DOMContentLoaded' , () =>{
    // collapse toggle    
    const collapseToggleModule = document.querySelectorAll('.js_collapse_toggle');

    class collapseToggle {
        constructor(target) {
            this.target = target;
            this.collapseToggleBtnArray = Array.from(this.target.querySelectorAll('.js_collapse_btn'));
        }
    
        collapseToggleFn() {
            const _this = this;
            
            this.collapseToggleBtnArray.forEach(function(el,index){
                el.addEventListener("click" , function(){
                    if(el.classList.contains('active')){
                        el.classList.remove('active');
                    }else{
                        el.classList.add('active');
                    }
                })
            })
        }
    }    
    collapseToggleModule.forEach(el => {        
        new collapseToggle(el).collapseToggleFn();
    });
});